export const PUBLIC_EMAIL_PROVIDERS = [
  'icloud.com',
  'facebook.com',
  'mac.com',
  'cs.com',
  'attcanada.ca',
  'optonline.net',
  'verison.net',
  'cal.vsnl.net.in',
  'sbcglobal.com',
  'adttsa.com',
  'adelphia.net',
  'boltblue.com',
  'address.com',
  'tivejo.com',
  'freenet.co.uk',
  'worldnet.att.net',
  'df1.telmex.net.mx',
  'md3.vsnl.net.in',
  'del3.vsnl.net.in',
  'mindspring.com',
  'del2.vsnl.net.in',
  'compuserve.com',
  'hathway.com',
  'maxis.net.my',
  'qc.aira.com',
  'fx.ro',
  'mtu-net.ru',
  'earthlink.net',
  'busmail.net',
  'online.be',
  'ekit.com',
  'proj2000.com',
  'allstream.net',
  'bluebottle.com',
  'juno.com',
  'coastalnet.com',
  'bart.nl',
  'banet.net',
  'gateway.net',
  'hotmail.com</div',
  'eth.net',
  'madasafish.com',
  'riseup.net',
  'dnet.net.id',
  'total.net',
  'istar.ca',
  'tinet.ie',
  'nexo.es',
  'xnet.ro',
  'telefonica.net.pe',
  'bom3.vsnl.net.in',
  'globalnet.co.uk',
  'satyam.net.in',
  'ic24.net',
  'yubc.net',
  'dreamwiz.com',
  'prodigy.net',
  'village.uunet.be',
  'telocity.com',
  'sbcglobal.net',
  'sprint.ca',
  'fastmail.us',
  'email.de',
  'pixie.co.za',
  'pocketmail.com',
  'datamarkets.com.ar',
  'mail.vresp.com',
  'att.net',
  'bom8.vsnl.net.in',
  'which.net',
  'worldonline.be',
  'post3.tele.dk',
  'one.net.au',
  'public3.bta.net.cn',
  'zoom.co.uk',
  'interactive.net.ec',
  'algonet.se',
  'blazenet.net',
  'ptt.yu',
  'infonegocio.com',
  'tie.cl',
  'acenet.co.za',
  'spamarrest.com',
  'mexico.com',
  'onlinehome.de',
  'charter.net',
  'care4free.net',
  'axtel.net',
  'direct.ca',
  'ms24.hinet.net',
  'accamail.com',
  'online.ru',
  'clara.net',
  'sancharnet.in',
  'best.com',
  'time.net.my',
  'efaxsend.com',
  'concentric.net',
  'aliceposta.it',
  'ms17.hinet.net',
  'online.sh.cn',
  'btclick.com',
  'uio.satnet.net',
  'cybercable.fr',
  'picknowl.com.au',
  'wanadoo.be',
  'xmsnet.nl',
  'firehousemail.com',
  'freemail.absa.co.za',
  'public.bta.net.cn',
  'neostrada.pl',
  'wish.net',
  'look.ca',
  'worldonline.dk',
  'onetel.net',
  'retemail.es',
  'net.novis.pt',
  'turk.net',
  'gye.satnet.net',
  'venali.net',
  'cadvision.com',
  'ice.co.cr',
  'net.sy',
  'wolmail.nl',
  'entelnet.bo',
  'mozcom.com',
  'online.fr',
  'ttnet.net.tr',
  'hunterlink.net.au',
  'wave.co.nz',
  'facebookmail.com',
  'onemain.com',
  'msn.com',
  'ca.inter.net',
  'senet.com.au',
  'netway.at',
  'pc.jaring.my',
  'mybluelight.com',
  'sol.racsa.co.cr',
  'direcway.com',
  'pipeline.com',
  '163.net',
  'tutopia.com',
  'mobileemail.vodafone.net',
  'plaxo.com',
  'hkstar.com',
  'zen.co.uk',
  'toad.net',
  'hotkey.net.au',
  'sprintpcs.com',
  'mms.att.net',
  'saunalahti.fi',
  'cloud9.net',
  'infinito.it',
  'stonline.sk',
  'inode.at',
  'domain.com.br',
  'interlog.com',
  'hamburg.de',
  'sion.com',
  'usit.net',
  'china.com',
  'cyberway.com.sg',
  'softbank.ne.jp',
  'intergate.com',
  'uswest.net',
  'indo.net.id',
  'jcom.home.ne.jp',
  'mb.sympatico.ca',
  'lycos.de',
  'islandnet.com',
  'barak-online.net',
  'ipa.net',
  'en.com',
  'isp.com',
  'tip.nl',
  'yeah.net',
  'starband.net',
  'lanset.com',
  'woosh.co.nz',
  'tele2.it',
  'buffalo.com',
  'itelgua.com',
  'nets.com.jo',
  'prodigy.com',
  'interbaun.com',
  'esoterica.pt',
  'quest.net',
  'unwired.com.au',
  'midwest.net',
  'po.jaring.my',
  'impsat1.com.ar',
  'kih.net',
  'att.net.mx',
  'bellsouth.net',
  'telus.blackberry.net',
  'compusmart.ab.ca',
  'bom5.vsnl.net.in',
  'internet-zahav.net',
  'terra.com.mx',
  'webtv.com',
  'aol.co',
  'izoom.net',
  'kornet.net',
  'mninter.net',
  'internet.gr',
  'infonie.fr',
  'telnor.net',
  'alumni.vanderbilt.edu',
  'wans.net',
  'andinanet.net',
  'pi.be',
  'viaccess.net',
  'edpnet.be',
  'onetel.net.uk',
  'sentoo.sn',
  'cwcom.net',
  'gmx.com',
  'minister.com',
  'bellnet.ca',
  'gotsky.com',
  'infionline.net',
  'sulanet.net',
  'pd.jaring.my',
  'speedy.com.pe',
  'entelchile.net',
  'eunet.yu',
  'earthlink.com',
  'loxinfo.co.th',
  'tiscali.ch',
  'mail.hz.zj.cn',
  'passagen.se',
  'rdslink.ro',
  'biznetvigator.com',
  'gis.net',
  'pldtdsl.net',
  'uolsinectis.com.ar',
  'dialdata.com.br',
  'worldpath.net',
  'wolfenet.com',
  'adept.co.za',
  'well.com',
  'toucansurf.com',
  'worldonline.fr',
  'vzwpix.com',
  'nb.net',
  'teliamail.dk',
  'hn.vnn.vn',
  'mba1999.hbs.edu',
  'tedata.net.eg',
  'crosslink.net',
  'image.dk',
  'utanet.at',
  'a1.net',
  'versateladsl.be',
  'i2k.com',
  'ibm.net',
  'centrin.net.id',
  'megared.net.mx',
  'infosel.net.mx',
  'unitel.co.kr',
  'hotmail.es',
  'truevine.net',
  'yebo.co.za',
  'quixnet.net',
  'supanet.com',
  'on.aibn.com',
  'milwpc.com',
  'mediaone.net',
  'cscoms.com',
  'sprynet.com',
  'cablenet.com.ni',
  'joimail.com',
  'iae.nl',
  'alphalink.com.au',
  'adr.dk',
  'pm.sprint.com',
  'his.com',
  'netcom.com',
  'nordnet.fr',
  'cts.com',
  'eureka.lk',
  'snip.net',
  'euronet.nl',
  'hotmail.com.mx',
  'ukonline.co.uk',
  'triton.net',
  'vsnl.com',
  'enteract.com',
  'hknet.com',
  'yucom.be',
  'gil.com.au',
  'tiac.net',
  'planet.tn',
  'etb.net.co',
  'jazzfree.com',
  'wanadoo.mg',
  'sinectis.com.ar',
  'adslhome.dk',
  'chello.se',
  '263.net',
  'netcom.ca',
  'prw.net',
  'ksc.th.com',
  'dial.oleane.com',
  'vtxmail.ch',
  'live.fr',
  'penn.com',
  'mail.ev1.net',
  '21cn.com',
  'voyager.net',
  'menara.ma',
  'wbs.co.za',
  'brturbo.com.br',
  'intouch.com',
  'guate.net.gt',
  'cix.co.uk',
  'dial.pipex.com',
  'fpt.vn',
  'pressenter.com',
  'net.sapo.pt',
  'aliceadsl.fr',
  'gol.com',
  'arkansas.net',
  'live.com.mx',
  'cotas.com.bo',
  'bellatlantic.net',
  'verizon.net.do',
  'post7.tele.dk',
  'sinfo.net',
  'vodafone.it',
  'merr.com',
  'chariot.net.au',
  'zaz.com.br',
  'nextel.blackberry.net',
  'kcnet.com',
  'tiscali.fr',
  'core.com',
  'qualitynet.net',
  'euskalnet.net',
  'sh163.net',
  'wol.co.za',
  'dnai.com',
  'tiscali.co.za',
  'indigo.ie',
  'optonline.com',
  'qis.net',
  'ip.pt',
  'vip.163.com',
  'ihug.com.au',
  'gate.net',
  'elogica.com.br',
  'apk.net',
  'pop.net',
  'bestweb.net',
  'pnc.com.au',
  'alum.emory.edu',
  'onet.eu',
  'planetinternet.be',
  'africaonline.com.gh',
  'mailstation.com',
  'sherbtel.net',
  'city.dk',
  'globetrotter.net',
  'gmail.com',
  'ibw.com.ni',
  'netactive.co.za',
  'hotmail.com',
  'teledisnet.be',
  'cox.net',
  'mail.datanet.hu',
  'swiftkenya.com',
  'nb.aibn.com',
  'myjaring.net',
  'cfaith.com',
  'uk2.net',
  'illinoisalumni.org',
  'talkamerica.net',
  'indy.net',
  'movi.com.ar',
  'mpinet.net',
  'go.com.jo',
  'chello.be',
  'powerup.com.au',
  'mba1997.hbs.edu',
  'start.no',
  'wt.net',
  'euronet.be',
  'mesanetworks.net',
  'aug.com',
  'alum.berkeley.edu',
  'gega.net',
  'hcm.vnn.vn',
  'vsnl.net',
  'mtnl.net.in',
  'speedy.com.ar',
  'netgate.com.uy',
  'jps.net',
  'west.net',
  'atlas.cz',
  'uslink.net',
  'three.com.au',
  'voicenet.com',
  'onda.com.br',
  'mail1.stofanet.dk',
  'tm.net.my',
  'ttmail.com',
  'mt.net.mk',
  'ifrance.com',
  'intelnet.net.gt',
  'infomaniak.ch',
  '9online.fr',
  'mpx.com.au',
  'verizon.net',
  'eunet.rs',
  'dircon.co.uk',
  'netcarrier.com',
  'comcast.net',
  'telesat.com.co',
  'tinyworld.co.uk',
  'cwp.net.pa',
  'quik.com',
  'thegrid.net',
  'infoave.net',
  'erinet.com',
  'inco.com.lb',
  'f2s.com',
  'zbzoom.net',
  'tiscali.cz',
  'dixie-net.com',
  'iol.cz',
  'copper.net',
  'virginmedia.com',
  'netcomuk.co.uk',
  'pacific.net.hk',
  'go2.pl',
  'easynet.co.uk',
  'olympus.net',
  'mc.net',
  'justice.com',
  'talkmatch.com',
  'clara.co.uk',
  'newmail.dk',
  'candw.lc',
  'inbox.com',
  'btconnect.com',
  'cura.net',
  'nana.co.il',
  'aanet.com.au',
  'libertypr.net',
  'netc.pt',
  'mycingular.blackberry.net',
  'mos.com.np',
  'rcsis.com',
  'cfl.rr.com',
  'numericable.fr',
  'suscom.net',
  'accesswave.ca',
  'connect.com.fj',
  'shore.net',
  'carib-link.net',
  'malawi.net',
  'nni.com',
  'ukgateway.net',
  'datasync.com',
  'global.co.za',
  'alum.darden.edu',
  'terra.com.pe',
  'gnet.tn',
  'sprintmail.com',
  'bdg.centrin.net.id',
  'asiaonline.net',
  'vol.net.mt',
  'online.de',
  'tiscalinet.it',
  'icehouse.net',
  'panix.com',
  'nj.rr.com',
  'altrionet.com',
  'aol.com',
  'iee.org',
  'webtv.net',
  'intekom.co.za',
  'totalise.co.uk',
  'katewwdb.com',
  'netangola.com',
  'indosat.net.id',
  'intrex.net',
  '017.net.il',
  'mcn.net',
  'cg.yu',
  'ltdkate.com',
  'wmconnect.com',
  'post.olivant.fo',
  'ecentral.com',
  'centennialpr.net',
  'cybertrade.co.za',
  'comast.net',
  'samart.co.th',
  'quick.cz',
  'wwdb.org',
  'yahoo.pl',
  'onetel.com',
  'covad.net',
  'sfr.fr',
  'lvcm.com',
  'aracnet.com',
  'charterinternet.com',
  'streamyx.com',
  'ij.net',
  'dls.net',
  'empal.com',
  'mweb.co.zw',
  'orange.net',
  'portima.be',
  'interaccess.com',
  'stargate.net',
  'frisurf.no',
  'localnet.com',
  'execpc.com',
  'dataone.in',
  'inreach.com',
  'cheqnet.net',
  'sport.dk',
  'openlink.com.br',
  'hevanet.com',
  'home.com',
  'alumni.indiana.edu',
  'igc.org',
  'intercable.net',
  'optushome.com.au',
  'post10.tele.dk',
  'cybertrails.com',
  'vip.sina.com',
  'intelnett.com',
  'planetkc.com',
  'palnet.com',
  'alamedanet.net',
  'viabcp.com',
  'isd.net',
  'fone.net',
  'data.net.mx',
  'ono.com',
  'post9.tele.dk',
  'worldonline.co.za',
  'midcoast.com',
  'arrakis.es',
  'netnet.net',
  'nucleus.com',
  'ameritrade.com',
  'ua.fm',
  'the-beach.net',
  'enter.net',
  'capecod.net',
  'pacific.net.ph',
  'siol.net',
  'antwerpen.be',
  'austarnet.com.au',
  'ciudad.com.ar',
  'saber.net',
  '126.com',
  'callatg.com',
  'together.net',
  'classicnet.net',
  'smartchat.net.au',
  'shreve.net',
  'fidalgo.net',
  'tele2.fr',
  'ctcinternet.cl',
  'volja.net',
  'chorus.net',
  'dbmail.dk',
  'poste.it',
  'storm.ca',
  'sport.rr.com',
  'ajato.com.br',
  'itelefonica.com.br',
  'rad.net.id',
  'bscn.com',
  'tmo.blackberry.net',
  'cwo.com',
  'spidernet.com.cy',
  'inter.nl.net',
  'shawcable.com',
  'cwnet.com',
  'dreamscape.com',
  'brutele.be',
  'ya.com',
  'mclink.it',
  'iol.ie',
  'paonline.com',
  'alaweb.com',
  'chol.com',
  'takas.lt',
  'bol.net.in',
  'superonline.com',
  'hcm.fpt.vn',
  'uninet.com.br',
  'qtm.net',
  'cyberia.net.lb',
  'nifty.com',
  'c.dk',
  'cbn.net.id',
  'gte.net',
  'live.de',
  'azbar.org',
  'theriver.com',
  'vom.com',
  'utvinternet.com',
  'swissonline.ch',
  'alumni.virginia.edu',
  'flash.net',
  'msa.hinet.net',
  'pixi.com',
  'telecom.net.et',
  'cstone.net',
  'dglnet.com.br',
  'bww.com',
  'compuserve.de',
  'alum.wellesley.edu',
  'sisna.com',
  'alumni.unc.edu',
  'gmx.co.uk',
  'cwpanama.net',
  'mcleodusa.net',
  'pcisys.net',
  'primus.com.au',
  'chello.no',
  'midconetwork.com',
  'worldonline.nl',
  'tinyonline.co.uk',
  'aloha.net',
  'yahoo.com',
  'inet.hr',
  'linkline.com',
  'inter.net.il',
  'primus.ca',
  'stic.net',
  'noemail.com',
  'teleport.com',
  'xplornet.com',
  'pacifier.com',
  'io.com',
  'netdoor.com',
  'primenet.com',
  'chibardun.net',
  'jfaxsend.com',
  'kos.net',
  'velocity.net',
  'newmexico.com',
  'golden.net',
  'freesurf.ch',
  'snafu.de',
  'live.it',
  'fea.net',
  'alumni.purdue.edu',
  'pacific.net.au',
  'access.ch',
  'vaxxine.com',
  'mail.sy',
  'pp.inet.fi',
  'racsa.co.cr',
  'sprint.blackberry.net',
  'superig.com.br',
  'graduate.hku.hk',
  'mail.telepac.pt',
  'nifty.ne.jp',
  'alumni-gsb.stanford.edu',
  'tvcabo.co.mz',
  'myacc.net',
  'epm.net.co',
  'iburst.co.za',
  'sinaman.com',
  'nethere.com',
  'athenet.net',
  'chello.hu',
  'onthenet.com.au',
  'nildram.co.uk',
  'avantel.net',
  'dds.nl',
  'texoma.net',
  'aol.in',
  'alumni.stanford.org',
  'batelnet.bs',
  'ma.ultranet.com',
  'bluezone.no',
  'alumni.tufts.edu',
  'aon.at',
  'polka.co.za',
  'ix.netcom.com',
  'post.cybercity.dk',
  'caribe.net',
  'euromail.se',
  'hanafos.com',
  'seidata.com',
  'jam.rr.com',
  'sensewave.com',
  'megsinet.net',
  'datacomm.ch',
  'hol.gr',
  'rof.net',
  'texas.net',
  'pga.com',
  'lineone.net',
  'amtelecom.net',
  'monmouth.com',
  'tdcadsl.dk',
  'swipnet.se',
  'westnet.com.au',
  'swing.be',
  'netsite.com.br',
  'mnsi.net',
  'warwick.net',
  'zg.htnet.hr',
  'info.com.ph',
  'filternet.nl',
  'candw.ag',
  'centroin.com.br',
  'drizzle.com',
  'suscom-maine.net',
  'truvista.net',
  'maplenet.net',
  'vnet.net',
  'nauticom.net',
  'icon.co.za',
  'ec-red.com',
  'nemontel.net',
  'unidial.com',
  'live.be',
  'txt.att.net',
  'nac.net',
  'softcom.net',
  'arrl.net',
  'bell.net',
  'wanadoo.dk',
  'i-55.com',
  'super.net.pk',
  'bizec.rr.com',
  'homecall.co.uk',
  'codetel.net.do',
  'dm.net.lb',
  'massmed.org',
  'pathcom.com',
  'etcmail.com',
  'cableonda.net',
  'amigo.net',
  'zol.co.zw',
  'ricochet.net',
  'nctc.com',
  'afo.net',
  'integrity.com',
  'tciway.tc',
  'oz.net',
  'provide.net',
  'vzw.blackberry.net',
  'online.nl',
  'cable.net.co',
  'tiscali.dk',
  'amaonline.com',
  'colorado.net',
  'ev1.net',
  'smile.ch',
  'vip.hr',
  'discoverymail.co.za',
  'bk.ru',
  'wol.net.pk',
  'alumni.brown.edu',
  'sk.sympatico.ca',
  'vp.pl',
  'citiz.net',
  'attbi.com',
  'tiscali.no',
  'dsl.pipex.com',
  'aapt.net.au',
  'isomedia.com',
  'fiberpipe.net',
  'concepts.nl',
  'netspeed.com.au',
  'swiftdsl.com.au',
  'iam.net.ma',
  'olg.com',
  'live.no',
  'tmail.com',
  'airtelmail.in',
  'infi.net',
  'worldcom.ch',
  'live.co.za',
  'telcel.net.ve',
  'colomsat.net.co',
  'smartneighborhood.net',
  'starhub.net.sg',
  'tnn.net',
  'rconnect.com',
  'one.net',
  'tref.nl',
  'brain.net.pk',
  'solcon.nl',
  'unisys.com.br',
  'wildblue.net',
  'alumni.uchicago.edu',
  'ma.rr.com',
  'dir.bg',
  'post.pl',
  'moment.net',
  'zg.t-com.hr',
  'imt.net',
  'wn.com.au',
  'cegetel.net',
  'cpinternet.com',
  'oncable.dk',
  'tulsacoxmail.com',
  'tld.net',
  'megavision.com',
  'hal-pc.org',
  'pa.net',
  'y7mail.com',
  'dca.net',
  'netspace.net.au',
  'acd.net',
  'ath.forthnet.gr',
  'dmv.com',
  'netsync.net',
  'indra.com',
  'mountaincable.net',
  'libertysurf.fr',
  'live.se',
  'lightspeed.net',
  'zip.com.au',
  'idx.com.au',
  'mosquitonet.com',
  'nwlink.com',
  'une.net.co',
  'ya.ru',
  'exemail.com.au',
  'alumni.usc.edu',
  'brainerd.net',
  'getmail.no',
  'iglou.com',
  'seed.net.tw',
  'montana.com',
  'aol.co.uk',
  'starpower.net',
  'bigmir.net',
  'alumni.caltech.edu',
  'netcommander.com',
  'wcnet.org',
  'ptialaska.net',
  'iafrica.com',
  'tiscali.de',
  'sierratel.com',
  'vermontel.net',
  'meetup.com',
  'sigecom.net',
  'ybb.ne.jp',
  'atlantic.net',
  'fast.net',
  'guam.net',
  'volny.cz',
  'cfw.com',
  'airmail.net',
  'waitrose.com',
  'wvi.com',
  'erols.com',
  'sympatico.com',
  'bluemarble.net',
  'excelonline.com',
  'adinet.com.uy',
  'prodigy.net.mx',
  'netvisao.pt',
  'ican.net',
  'eastex.net',
  'inforamp.net',
  'strato.net',
  'wanadoo.jo',
  'brturbo.com',
  'gpcom.net',
  'zappmobile.ro',
  'uniserve.com',
  'twlakes.net',
  'pdq.net',
  'csinet.net',
  'bayou.com',
  'tricom.net',
  'fairpoint.net',
  'ftc-i.net',
  'fdn.com',
  'psualum.com',
  'kconline.com',
  'ncn.net',
  'silcom.com',
  'accessus.net',
  'amnet.co.cr',
  'vcn.com',
  'iserv.net',
  'daktel.com',
  'midmaine.com',
  'glocalnet.net',
  'gofree.indigo.ie',
  'gtalumni.org',
  'lava.net',
  'tom.com',
  'vip.cybercity.dk',
  'inebraska.com',
  'zajil.net',
  'dakotacom.net',
  'mba2000.hbs.edu',
  'napanet.net',
  'net.hr',
  'dslextreme.com',
  'welho.com',
  '013.net.il',
  'eoni.com',
  'ceoexpress.com',
  't-online.hu',
  'yahoogroups.com',
  'sohu.com',
  'swfla.rr.com',
  'bham.rr.com',
  'cemsmail.org',
  'whidbey.net',
  'kingwoodcable.com',
  'snowcrest.net',
  'itctel.com',
  'netnitco.net',
  'cogeco.net',
  'birch.net',
  'yahoogrupos.com.br',
  'cgocable.ca',
  'integra.net',
  'wananchi.com',
  'megalink.net',
  'sunbeach.net',
  'dccnet.com',
  'academicplanet.com',
  'spiritone.com',
  'netcologne.de',
  'mho.com',
  'lantic.net',
  'frontier.net',
  'romandie.com',
  'primary.net',
  'yadtel.net',
  'integraonline.com',
  'terra.net.lb',
  'cox-internet.com',
  'span.ch',
  'mweb.com.na',
  'widomaker.com',
  'zoho.com',
  'alumni.haas.org',
  'actcom.co.il',
  'barak.net.il',
  'tesco.net',
  'estadao.com.br',
  'mi.cl',
  'brightok.net',
  'originet.com.br',
  'onr.com',
  'a3.epfl.ch',
  'eject.co.za',
  'xsinet.co.za',
  'optimum.net',
  'menanet.net',
  'mhtc.net',
  'pc.dk',
  'dodo.com.au',
  'efn.org',
  'cavtel.net',
  'alum.rpi.edu',
  'bol-online.com',
  'si.rr.com',
  'truemail.co.th',
  'live.com.pt',
  'tcsn.net',
  'mciworld.com',
  't.vodafone.ne.jp',
  'winfirst.com',
  'qx.net',
  'pop.com.br',
  'redshift.com',
  'belgacom.net',
  '12move.nl',
  'evansville.net',
  'nettally.com',
  'o2.ie',
  'alumni.upenn.edu',
  'montrose.net',
  'nuvox.net',
  'mn.rr.com',
  'vvm.com',
  'blackfoot.net',
  'rockisland.com',
  'gbis.com',
  'valley.net',
  'alum.bu.edu',
  'usinternet.com',
  'proaxis.com',
  'tin.it',
  'zamtel.zm',
  'sr.net',
  'up.net',
  'rambler.ru',
  'ripnet.com',
  'ksg07.harvard.edu',
  'alumnus.utwente.nl',
  'absamail.co.za',
  'mymailstation.com',
  'jerseymail.co.uk',
  'netconnect.com.au',
  'newwavecomm.net',
  'realtyagent.com',
  'alice.it',
  'directcon.net',
  'otelco.net',
  'live.com.au',
  'cistron.nl',
  'wk.net',
  'wamail.net',
  'alaska.com',
  'clearwire.net',
  'mwt.net',
  'toast.net',
  'htcomp.net',
  'iconet.com.br',
  '3rivers.net',
  'tbaytel.net',
  'info.bw',
  'nursat.kz',
  'pmt.org',
  'peak.org',
  'monaco.mc',
  'clear.net.nz',
  'voila.fr',
  't-online.de',
  'uclalumni.net',
  'live.in',
  'ntl.sympatico.ca',
  'telefonica.net',
  'ak.net',
  'beeb.net',
  'yahoo.com.tr',
  'volcano.net',
  'aircanopy.net',
  'conversent.net',
  'sopris.net',
  'speakeasy.net',
  'cybersmart.co.za',
  'pchome.com.tw',
  'shawbiz.ca',
  'orcon.net.nz',
  'innernet.net',
  'mines-paris.org',
  'alumni.rice.edu',
  'tele2.no',
  'netins.net',
  'zianet.com',
  'netsgo.com',
  'alumni.utexas.net',
  'active.ch',
  'fibertel.com.ar',
  'knoware.nl',
  'gsm.uci.edu',
  'dhaka.net',
  'pshift.com',
  'uai.com.br',
  'post.tele.dk',
  'taconic.net',
  'goeaston.net',
  'bigplanet.com',
  'messaging.sprintpcs.com',
  'tele2.ch',
  'arn.net',
  'vtx.ch',
  'mediacombb.net',
  'myclearwave.net',
  'people.net.au',
  'cal.berkeley.edu',
  'wxs.nl',
  'tiscali.es',
  'pld.com',
  'raha.com',
  'sirius.com',
  'vodafone.net',
  'alumni.nd.edu',
  'iol.pt',
  'cyber.net.pk',
  'cablespeed.com',
  'computer.org',
  'iib.ws',
  'pacific.net.sg',
  'os.dk',
  'club-internet.fr',
  'tiscalinet.ch',
  'cybermesa.com',
  'lmi.net',
  'internode.on.net',
  '013.net',
  'portoweb.com.br',
  'coqui.net',
  'kpnmail.nl',
  'vtr.net',
  'hrtc.net',
  'cebridge.net',
  'intrstar.net',
  'alumni.stanfordgsb.org',
  'proximedia.be',
  'cruzio.com',
  'oba.co.uk',
  'excel.net',
  'futurenet.co.za',
  'telesal.net',
  'att.blackberry.net',
  'mind.net',
  'personainternet.com',
  'garlic.com',
  'saol.com',
  'execulink.com',
  'alumni.wfu.edu',
  'magic.fr',
  'sedona.net',
  'pol.net',
  'mobile.att.net',
  'wvdsl.net',
  'noos.fr',
  'plusnet.pl',
  'adnc.com',
  'mx.inter.net',
  'suomi24.fi',
  'bmi.net',
  'kabsi.at',
  'unete.com',
  'axionet.com',
  'mpowercom.net',
  'easystreet.com',
  'elisanet.fi',
  'aaahawk.com',
  'hfx.eastlink.ca',
  'alumni.duke.edu',
  'grm.net',
  'ccim.net',
  'isat.co.za',
  'skybest.com',
  'netscape.com',
  'iland.net',
  'eatel.net',
  'stjoelive.com',
  'magma.ca',
  'tpgi.com.au',
  'pobox.com',
  'elmore.rr.com',
  'coralwave.com',
  'live.co.uk',
  'live.ca',
  'hixnet.co.za',
  'manx.net',
  'mcn.org',
  'mi.rr.com',
  'scarlet.be',
  'vodafone.es',
  'caiway.nl',
  'blomand.net',
  'commspeed.net',
  'datazug.ch',
  'caribsurf.com',
  'ihug.co.nz',
  'gwi.net',
  'pbhkgs013.pbgroup.local',
  'cmaaccess.com',
  'cablelynx.com',
  'tc3net.com',
  'ibest.com.br',
  'live.dk',
  'imaginet.co.za',
  'tconl.com',
  'waldonet.net.mt',
  'clix.pt',
  'aster.pl',
  'link.com.eg',
  'iquest.net',
  'mweb.co.za',
  'persona.ca',
  'acsalaska.net',
  'tele2.nl',
  'sw.rr.com',
  'realnet.co.sz',
  'paran.com',
  'email.dk',
  'nl.rogers.com',
  'zamnet.zm',
  'hotmail.co.jp',
  'gvmail.br',
  'yahoo.com.ph',
  'crocker.com',
  'megapathdsl.net',
  'lexcominc.net',
  'googlegroups.com',
  'newnorth.net',
  'voliacable.com',
  'it.dk',
  'nvbell.net',
  'netti.fi',
  'stratos.net',
  'live.cn',
  'aviso.ci',
  'neuf.fr',
  'botsnet.bw',
  'mycomcast.com',
  'ggaweb.ch',
  'teledata.mz',
  'psci.net',
  'prtc.net',
  'windowslive.com',
  'kingsley.co.za',
  'suddenlinkmail.com',
  'frii.com',
  'nts-online.net',
  'entouch.net',
  'ca.rr.com',
  'rgv.rr.com',
  'ccrtc.com',
  'bendcable.com',
  'stx.rr.com',
  'rap.midco.net',
  'bway.net',
  'nesma.net.sa',
  'stofanet.dk',
  'graceba.net',
  'eim.ae',
  'orange.nl',
  'nctv.com',
  'iway.na',
  'uwalumni.com',
  'tele2.at',
  'goldrush.com',
  'qatar.net.qa',
  'wispertel.net',
  'btopenworld.com',
  'ntelos.net',
  'usamedia.tv',
  'dishmail.net',
  'metroweb.co.za',
  'harbornet.com',
  'comhem.se',
  'wyoming.com',
  'kabelfoon.nl',
  'movistar.net.ve',
  'emirates.net.ae',
  'alumni.clemson.edu',
  'wol.be',
  'lisco.com',
  'yahoo.cn',
  'madriver.com',
  'y.net.ye',
  'patmedia.net',
  'bendbroadband.com',
  'fastwebnet.it',
  'isbank.net.tr',
  'nvc.net',
  'sover.net',
  'costarricense.cr',
  'wlink.com.np',
  'astound.net',
  'wctc.net',
  'nexicom.net',
  'cytanet.com.cy',
  'northwestel.net',
  'europa.com',
  'scrtc.com',
  'ntin.net',
  'maxnet.co.nz',
  'nf.sympatico.ca',
  'bangla.net',
  'chello.at',
  'ibl.bm',
  'mba2003.hbs.edu',
  'mtnloaded.co.za',
  'mydestiny.net',
  'outdrs.net',
  'docomo.ne.jp',
  'pacific.net',
  'onenet.an',
  'primusonline.com.au',
  'idm.net.lb',
  'oh.rr.com',
  'connecttime.net',
  'tstar.net',
  'vodamail.co.za',
  'helloworld.com',
  'tee.gr',
  'pt.lu',
  'compass.com.ph',
  'olp.net',
  'hispeed.ch',
  'urbanet.ch',
  'talktalk.net',
  'ritz.edu',
  'theramp.net',
  'netvigator.com',
  'netmadeira.com',
  'mba2001.hbs.edu',
  'mywdo.com',
  'alumni.esade.edu',
  'tstt.net.tt',
  'scarlet.nl',
  'directnet.com.br',
  'sonic.net',
  'telkomsa.net',
  'mailme.ae',
  'orange.fr',
  'intnet.mu',
  'ite.net',
  'sltnet.lk',
  'visi.com',
  'op.pl',
  'alumni.princeton.edu',
  'aristotle.net',
  'shasta.com',
  'uq.net.au',
  'pei.sympatico.ca',
  'iw.net',
  'kolumbus.fi',
  'telstra.com',
  'qnet.com',
  'platinum.ca',
  'internet.lu',
  'gsinet.net',
  'macau.ctm.net',
  'catt.com',
  'nb.sympatico.ca',
  'online.com.kh',
  'tlen.pl',
  'zahav.net.il',
  'chartermi.net',
  'clear.net',
  'upcmail.nl',
  'novuscom.net',
  'alum.dartmouth.org',
  'cwjamaica.com',
  'xmission.com',
  'alumni.sfu.ca',
  'mynet.com',
  'prairieinet.net',
  'de.debitel.com',
  'homesc.com',
  'alum.wpi.edu',
  'srt.com',
  'ticnet.com',
  'tut.by',
  'rcn.com',
  'get2net.dk',
  'mt.net',
  'starstream.net',
  'lpbroadband.net',
  'nbnet.nb.ca',
  'alumni.unisg.ch',
  'pldi.net',
  'oi.com.br',
  'best.eu.org',
  'ruraltel.net',
  'actcom.net.il',
  'ziggo.nl',
  'centurylink.net',
  'mobile.mycingular.com',
  'sunrise.ch',
  'airmessage.net',
  'slingshot.co.nz',
  'yahoo.co.in',
];
